export const rotatingPromoBarClicked = (text, target) => ({
  type: 'Rotating Promo Bar Clicked',
  data: { text, target },
});
